import React from 'react';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getDefaultWidgetConfigs, getEventDetailsHash, getRemoteConfigs } from '../utils';
import MeetingRequestsStatusWidgetBody from './body';
import { getEventDetailsForDateFilter } from '../../../generic/Actions/WidgetActions/DateFilter/utils';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';

/*
props = {
  data: {
    uId: <uniqueIdentifier>,
    name: <string>,
    className: <string>,
    url: <string>
  }
}
*/

export const exportEventName = "meetingRequestsStatusExportChart";

const MeetingRequestsStatus = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, className: "dynamic-grid-item" });
  const filterKey = 'requestsSent';

  const configBuilder = (state) => {
    return {
      remoteOptions: getRemoteConfigs(url, MeetingRequestsStatusWidgetBody, { filters: getCommonDateRangeWithPresetFilterValue(state, filterKey, 'requests_sent_date_range') })
    };
  };

  const eventDetailsBuilder = (state) => {
    const { eventName, dateRange, preset } = getEventDetailsForDateFilter(state, { filterKey })

    return getEventDetailsHash({ eventName, source: name, dateRange, preset, eventCategory: props.eventCategory });
  }

  const { actions, widgetConfig } = useWidgetActionsBuilder(actionsData, configBuilder, { exportEventName, eventDetailsBuilder });

  return (
    <ChrWidget
      { ...defaultWidgetConfigs }
      header={ name }
      headerActions={ actions.headerActions }
      footerActions={ actions.footerActions }
      { ...widgetConfig.remoteOptions }
    />
  );
};

export default MeetingRequestsStatus;